import defaultImg from '@/assets/images/200.png'
/* import ShCarousel from './sh-carousel'
import ShMore from './sh-more.vue'
import ShSkeleton from "./sh-skeleton.vue"
import ShBread from "./sh-bread.vue"
import ShBreadItem from "./sh-bread-item.vue"
 */
//context('目录路径'，'是否加载子目录','加载文件匹配的正则表达式')
const importFn = require.context('./',false,/\.vue$/)

//扩展vue'原有功能： 全剧组件，自定义指令，挂载原型方法，注：无全局过滤器
//vue3.0插件写法 如果要挂载原型方法为app.comfig.globalProperties.$http

export default {
  install (app) {
    /* app.component(ShCarousel.name, ShCarousel);
    app.component(ShMore.name, ShMore);
    app.component(ShSkeleton.name, ShSkeleton);
    app.component(ShBread.name, ShBread);
    app.component(ShBreadItem.name, ShBreadItem)
    */
    //定义一个指令
    defineDirective(app);
    //定义面包屑组件
    

    importFn.keys().forEach(path => {
      const component = importFn(path).default
      //组件注册
      app.component(component.name,component)
    });

  }
}

//定义指令
const defineDirective = (app) =>{
  //图片懒加载指令
  //原理：现将图片地址储存在src上面 当图片进入可视区域，
  //将储存的图片地址设置给图片元素即可
  // 
  app.directive('lazy',{
    //vue2.0 监听使用指令的DOM是否川谷剑豪，钩子函数： inserted
    //vue3.0 指令钩子函数和组件一样，使用指令的DOM是否创建好，钩子函数：mounted
    mounted(el, binding) {
      //创建一个观察对象，来观察当前使用指令的元素
      const observer = new IntersectionObserver(([{isIntersecting}]) =>{
        if(isIntersecting) {
          //停止观察
          observer.unobserve(el)
          //处理图片加载失败的情形
          el.onerror = () =>{
            el.src = defaultImg
          }
          //把指令的值设置给el的src属性
          el.src = binding.value
        }
      },{
        threshold:0
      }) 
      //开始观察
      observer.observe(el)
    }
  })
}